export const DECLINATION_STATUS = {
  NoOffer: 'NoOffer',
  Declined: 'Declined'
};

export const DECLINATION_REASONS_FIELD_NAMES = {
  DeclinedFields: 'declined_fields',
  DeclinationNotes: 'declination_notes'
};

export const NO_OFFER_REASONS = [
  'Accepted another position (not through us)',
  'Accepted another position (through us)',
  'Candidate skillset does not match',
  'Company filled position (not through us)',
  'Company filled position (through us)',
  'Culture and personality does not match',
  'Salary expectation too high'
];

export const DECLINED_REASONS = [
  'Accepted another position (not through us)',
  'Accepted another position (through us)',
  'Company filled position (through us)',
  'Counteroffer',
  'Doesn’t want to make a change anymore',
  'Not a good fit',
  'Offer was too low',
  'Other Reason'
];
